var React = require('react');

function BackTopArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".box{fill:#f19a3e;}.arrow{fill:none;stroke:#fff;stroke-width:2px;}")),React.createElement("g",{"id":"Group_449","data-name":"Group 449","key":1},[React.createElement("rect",{"id":"box","className":"box","width":"44","height":"44","key":0}),React.createElement("g",{"id":"arrow","key":1},[React.createElement("path",{"id":"Path_218","data-name":"Path 218","className":"arrow","d":"M21.76,44V13.65","key":0}),React.createElement("path",{"id":"Path_219","data-name":"Path 219","className":"arrow","d":"M15,20.27505l6.9-6.9,6.9,6.9","key":1})])])]);
}

BackTopArrow.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 44 44"};

module.exports = BackTopArrow;

BackTopArrow.default = BackTopArrow;
